import AdminVariable from "./AdminVariable";
export default AdminVariable;
